/** Chart theming. Hex rather than classes: Recharts paints SVG, not DOM. */

import { CHART_ALERT_COLOR, CHART_SERIES_COLOR } from "~/lib/chartPalette";
import { ScoreBand } from "./scoring";

/**
 * Plot height for the charts and for the placeholder that stands in while their
 * data is in flight, so the card cannot change height when one replaces the other.
 */
export const EVAL_CHART_HEIGHT_CLS = "h-[220px]";

/**
 * The score band fills again, as literal hex for canvas. Duplicated rather than
 * derived because chart.js cannot resolve a CSS custom property and the
 * `--color-*` tokens are `@theme inline`, so they emit no runtime value. Keep in
 * step with the `cellClass` steps above.
 */
export const SCORE_BAND_HEX = {
  light: {
    [ScoreBand.CORRECT]: "#cdeee0",
    [ScoreBand.MOSTLY_CORRECT]: "#67cba0",
    [ScoreBand.MOSTLY_INCORRECT]: "#d76582",
    [ScoreBand.INCORRECT]: CHART_ALERT_COLOR.light,
  },
  dark: {
    [ScoreBand.CORRECT]: "#004226",
    [ScoreBand.MOSTLY_CORRECT]: "#32b87e",
    [ScoreBand.MOSTLY_INCORRECT]: "#cc3359",
    [ScoreBand.INCORRECT]: CHART_ALERT_COLOR.dark,
  },
} as const satisfies Record<"light" | "dark", Record<ScoreBand, string>>;

/**
 * The spread, drawn as a wash of the trend's own hue. One hue and not a trace per
 * agent: green and red are spoken for by the score ramp, and the remaining
 * non-status hues do not survive an all-pairs CVD check against each other, so
 * the agent facet narrows the series instead.
 */
export const TREND_SPREAD_FILL = {
  light: `${CHART_SERIES_COLOR.light}1a`,
  dark: `${CHART_SERIES_COLOR.dark}1a`,
} as const;
